module.exports = __webpack_public_path__ + "static/splint_armor-89ff8c2ece02a5ab350f4ad63839c63a.jpg";